import * as React from 'react';
export const IcSecurityCameraBall = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.64 8.34a8 8 0 00-10.1-1 8 8 0 00-1.21 12.3 7.91 7.91 0 004.1 2.19 8 8 0 007.21-13.5v.01zm-3.53 7.78a3 3 0 01-4.89-1 3 3 0 013.92-3.92 3 3 0 011 4.89l-.03.03zM12 13a1 1 0 100 2 1 1 0 000-2zM7.25 4.49c.095.1.211.175.34.22a.89.89 0 00.4.07.93.93 0 00.4-.09 10 10 0 017.28 0 1 1 0 00.36.07 1 1 0 00.63-.24.94.94 0 00.34-.58 1 1 0 00-.61-1.11 11.93 11.93 0 00-8.72 0 .89.89 0 00-.36.17.9.9 0 00-.25.33.9.9 0 00-.1.39 1 1 0 00.04.43c.06.129.145.244.25.34z'
      fill='currentColor'
    />
  </svg>
);
